/**
 *
 * @param {*} size 请求的数量
 * @param {*} param 额外需要传的参数，如开启多语言时候languageId,修改pageSize等等
 */
function GetIndexCatalogue(size=1,param={}) {
    const defaultPayload = {
        ...this.$store.state.defaultPayload,
        pageSize: 8,
        pageNum: 1,
        ...param,
    }
    return new Promise(resolve => {
        for(let i=0; i<size; i++){
            const value = `catalogueData_${i}`
            const payload = {
                locationId: i+1,
            }
            this.$store.dispatch('GET_DATA',{
                key: 'catalogue',
                value,
                payload:{...defaultPayload,...payload}
            }).then(()=>{
                this[`${value}`] = this.$store.state[`${value}`]
                if(i+1 === size){
                    resolve()
                }
            })
        }
    })
}
/**
 *
 * @param {*} that 页面的this
 * @param {*} key 请求的数据字段，详情请见./action.js下的Url
 * @param {*} value 生成数据的字段，store存储的值
 * @param {*} payload 请求参数
 */
function GetInitData(key,value,payload){
    const defaultPayload = {
        ...this.$store.state.defaultPayload,
        ...payload,
    }
    return this.$store.dispatch('GET_DATA',{
        key,
        value,
        payload:defaultPayload
    })
}
/** 提交表单
 * payload  请求参数
 * 结合封装
 * */
function PostAddMessage(payload={}){
    return GetInit(this,'addMessage','addMessage',payload)
}
// function PostAddMessage(payload) {
//
//     const defaultPayload = {
//         ...this.$store.state.defaultPayload,
//         ...payload,
//     }
//     return this.$store.dispatch('GET_DATA',{
//         key:'addMessage',
//         value:"addMessage",
//         payload:defaultPayload
//     })
//
// }


function GetInit(that,key,value,payload){
    const defaultPayload = {
        ...that.$store.state.defaultPayload,
        ...payload,
    }
    return that.$store.dispatch('GET_DATA',{
        key,
        value,
        payload:defaultPayload
    })
}
//获取多媒体
function GetMultimediaData(payload={}){
    return GetInit(this,'multimedia','multimediaData',payload)
}
//获取菜单
function GetMenuData(payload={}){
    return GetInit(this,'menu','menuData',payload)
}
//获取轮播图
function GetSlideData(payload={}){
    return GetInit(this,'slide','slideData',payload)
}
//获取底部导航
function GetMenuFootData(payload={}){
    return GetInit(this,'menu','menuFootData',payload)
}
//获取文章详情
function GetArticleData(payload={}){
    return GetInit(this,'article','articleData',payload)
}
//获取上下篇数据
function GetPreAndNext(payload={}){
    return GetInit(this,'preAndNext','preAndNext',payload)
}
//获取搜索数据结果
function GetSearchData(payload={}){
    return GetInit(this,'search','searchData',payload)
}
//获取列表
function GetCatalogueData(payload={}){
    return GetInit(this,'catalogue','catalogueData',payload)
}
//获取语言列表列表
function GetLanguagesData(payload={}){
    return GetInit(this,'languages','languagesData',payload)
}
// 获取面包屑
function GetBreadCrumb(payload={}){
    return GetInit(this,'breadCrumb','breadCrumbData',payload)
}
// 访问量统计
function GetStatistic(payload = {}) {
    return GetInit(this, 'statistic', 'statisticData', payload)
}
// 获取站点信息
function GetSiteInfo(payload = {}) {
    return GetInit(this, 'siteInfo', 'siteInfoData', payload)
}

//获取侧边栏数据
function GetMenuItemsData(payload={}){
    const { itemId=undefined, catalogueId=undefined } = payload
    const defaultPayload = {
        itemId,
        catalogueId,
    }
    if(catalogueId){
        const param = {
            type: 'ActiveMenuItem',
            data: catalogueId,
        }
        this.$store.commit('SAVE', param);
    }
    return this.$store.dispatch('GET_DATA',{
        key:'menuItems',
        value: 'menuItemsData',
        payload:defaultPayload
    })
}
// 语言修改
function ChangeLanguage(id) {
    window.sessionStorage.setItem('languageId',id)
    window.location.reload()
}
// 创建插件，挂载到全局函数中去
export default {
    install(Vue,options){
        Vue.prototype.$GetIndexCatalogue = GetIndexCatalogue
        Vue.prototype.$GetInitData = GetInitData
        Vue.prototype.$GetMenuData = GetMenuData
        Vue.prototype.$GetCatalogueData = GetCatalogueData
        Vue.prototype.$GetSlideData = GetSlideData
        Vue.prototype.$GetSearchData = GetSearchData
        Vue.prototype.$GetArticleData = GetArticleData
        Vue.prototype.$GetPreAndNext = GetPreAndNext
        Vue.prototype.$GetMenuFootData = GetMenuFootData
        Vue.prototype.$GetMenuItemsData = GetMenuItemsData
        Vue.prototype.$GetLanguagesData = GetLanguagesData
        Vue.prototype.$ChangeLanguage = ChangeLanguage
        Vue.prototype.$GetMultimediaData = GetMultimediaData
        Vue.prototype.$GetBreadCrumb = GetBreadCrumb
        Vue.prototype.$PostAddMessage = PostAddMessage
        Vue.prototype.$GetStatistic = GetStatistic
        Vue.prototype.$GetSiteInfo = GetSiteInfo
    },
}

